import React, { useState, useRef } from "react";
import { data, category } from "../data/data";
import { Link } from "react-router-dom";
import FoodOrder from "./FoodOrder";
import { motion } from "framer-motion"; // Import Framer Motion

const Food = () => {
    const sliderRef = useRef(null);
    const [foods, setFoods] = useState(data);

    // Scroll left
    const scrollLeftFunc = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: -250, behavior: "smooth" });
        }
    };

    // Scroll right
    const scrollRightFunc = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({ left: 250, behavior: "smooth" });
        }
    };

    const allArray = () => setFoods(data);

    const filterByCategory = (categoryData) => {
        const foodlist = data.filter((item) => item.category === categoryData);
        setFoods(foodlist);
    };

    return (
        <div name="order" className="max-w-[1640px] m-auto px-4 py-12">
            <h1 className="text-orange-600 font-bold text-4xl text-center mb-5">
                Top Rated Menu Items
            </h1>

            {/* Graphical Marquee */}
            <motion.div
                initial={{ x: "-100vw" }}
                animate={{ x: 0 }}
                transition={{ duration: 1, ease: "easeOut" }}
                className="relative overflow-hidden bg-gradient-to-r from-green-400 via-orange-200 to-pink-500 rounded-lg shadow-lg mb-5"
            >
                <div className="flex whitespace-nowrap items-center py-3 animate-marquee">
                    <span className="text-white font-bold text-2xl mx-10">
                        🎉 First-Time Users Offer: Get <span className="text-blue-500">50%</span> Off!
                    </span>
                    <span className="text-white font-bold text-2xl mx-10">
                        🥳 Bulk Order Discount: <span className="text-blue-500">25%</span> Off!
                    </span>
                    <span className="text-white font-bold text-2xl mx-10">
                        🎁 Don't Miss Out on Amazing Discounts!
                    </span>
                </div>
            </motion.div>

            {/* Filter Buttons */}
            <div className="flex flex-col lg:flex-row justify-between mb-6">
                <div>
                    <p className="font-bold text-gray-700">Filter Type</p>
                    <div className="flex flex-wrap gap-2">
                        <motion.button
                            whileTap={{ scale: 0.9 }}
                            className="border border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white px-4 py-2 rounded"
                            onClick={allArray}
                        >
                            All
                        </motion.button>
                        {category.map((item, index) => (
                            <motion.button
                                key={index}
                                whileTap={{ scale: 0.9 }}
                                className="border border-orange-600 text-orange-600 hover:bg-orange-600 hover:text-white px-4 py-2 rounded"
                                onClick={() => filterByCategory(item.category)}
                            >
                                {item.category}
                            </motion.button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Food Slider with Buttons */}
            <div className="relative w-full bg-gray-100 py-6">
                {/* Left Scroll Button */}
                <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={scrollLeftFunc}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-lg transition-all duration-300 transform hover:bg-orange-500"
        >
          ◀
        </motion.button>
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          onClick={scrollRightFunc}
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-gray-300 p-2 rounded-full shadow-lg transition-all duration-300 transform hover:bg-orange-500"
        >
          ▶
        </motion.button>


                {/* Scrollable Container */}
                <motion.div
                    ref={sliderRef}
                    className="flex space-x-4 overflow-x-scroll scroll-smooth cursor-grab px-10"
                    drag="x"
                    dragConstraints={{ left: -500, right: 500 }}
                    style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
                >
                    {foods.map((item, index) => (
                        <Link to={`/foodOrder/${item.id}`} key={index} element={<FoodOrder />}>
                            <motion.div
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                whileHover={{ scale: 1.05, boxShadow: "0px 5px 15px rgba(0,0,0,0.2)" }}
                                className="border rounded-lg shadow-xl w-60 hover:scale-105 duration-300"
                            >
                                <img
                                    src={item.image}
                                    alt={item.name}
                                    className="w-full h-[200px] object-cover rounded-t-lg"
                                />
                                <div className="flex justify-between items-center bg-orange-200 rounded-b-lg px-2 py-4">
                                    <p className="font-bold text-[20px] text-[tomato]">{item.name}</p>
                                    <p>
                                        <span className="bg-green-500 text-white p-2 rounded-full">
                                            <span className="text-xl font-bold">RS.{item.price}</span>
                                        </span>
                                    </p>
                                </div>
                            </motion.div>
                        </Link>
                    ))}
                </motion.div>

                {/* Right Scroll Button */}
                
            </div>
        </div>
    );
};

export default Food;
